export default {
    productSga2subsNotDangers: [],
};
